<!-- 听文章 -->
<template>
  <div class="page-article-listen" :class="{ mobile: isMobile }">
    <div class="header">
      <div class="back" @click="back">
        <img v-if="bookDetail.language === 1" src="@imgs/digital/to-paper-en.png" />
        <img v-else src="@imgs/digital/to-paper.png" />
      </div>
      <div class="title">{{ title }}</div>
    </div>
    <div class="main">
      <div class="edition" :class="{ edition_book: bookDetail.listenStyle === 1 }" v-for="(edition, index) in editions" :key="index">
        <div class="title" v-if="bookDetail.listenStyle !== 1">{{ edition.edition }}</div>
        <div class="article-list">
          <div class="article-item" v-for="(article, index1) in edition.xiaoYangList" :key="article.id" :class="{ active: xiaoYangId == article.id }" @click="handleXiaoYangClick(article.id)">
            <el-divider v-if="bookDetail.listenStyle !== 1 || !(index === 0 && index1 === 0)"></el-divider>
            <div class="title">{{ article.title }} <img src="@imgs/listen/playing.png" alt="" srcset="" /></div>
          </div>
        </div>
        <el-divider v-if="bookDetail.listenStyle !== 1"></el-divider>
      </div>
    </div>
    <div class="bottom">
      <div class="left" @click="prev" :class="[xiaoYangIndex != 0 ? 'useable' : 'disable']">
        <img src="@imgs/listen/left_play_active.png" class="activeImg" alt="" srcset="" />
        <img src="@imgs/listen/left_play_inactive.png" class="inActiveImg" alt="" srcset="" />
        上一篇
      </div>
      <div class="center" @click="resumeAudio">
        <img src="@imgs/listen/play.png" alt="" srcset="" v-show="isPause" />
        <img src="@imgs/listen/pause.png" alt="" srcset="" v-show="!isPause" />
      </div>
      <div class="right" @click="next" :class="[xiaoYangIndex != xiaoYangList.length - 1 ? 'useable' : 'disable']">
        下一篇
        <img src="@imgs/listen/right_play_active.png" class="activeImg" alt="" srcset="" />
        <img src="@imgs/listen/right_play_inactive.png" class="inActiveImg" alt="" srcset="" />
      </div>
    </div>
    <div class="digital-loading" v-if="dataLoading">
      <div class="text">加载中...</div>
    </div>
  </div>
</template>

<script>
import getBook from '@api/getBook'
import CryptoJS from 'crypto-js'
import { formatDigitalArticle, convertEnName } from '@/utils'
import { mapState } from 'vuex'
import TransWorker from '@/plugins/transcode.worker.js'
import { Base64 } from 'js-base64'
let APPID = ''
let API_SECRET = ''
let API_KEY = ''
let transWorker = new TransWorker()
function getWebsocketUrl() {
  return new Promise((resolve, reject) => {
    var apiKey = API_KEY
    var apiSecret = API_SECRET
    var url = 'wss://tts-api.xfyun.cn/v2/tts'
    var host = location.host
    var date = new Date().toGMTString()
    var algorithm = 'hmac-sha256'
    var headers = 'host date request-line'
    var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/tts HTTP/1.1`
    var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret)
    var signature = CryptoJS.enc.Base64.stringify(signatureSha)
    var authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`
    var authorization = btoa(authorizationOrigin)
    url = `${url}?authorization=${authorization}&date=${date}&host=${host}`
    resolve(url)
  })
}
class TTSRecorder {
  constructor({ speed = 50, voice = 50, pitch = 50, voiceName = 'x3_guange', appId = APPID, text = '', tte = 'UTF8', defaultText = '请输入您要合成的文本', resumeCb, suspendCb } = {}) {
    this.speed = speed
    this.voice = voice
    this.pitch = pitch
    this.voiceName = voiceName
    this.text = text
    this.textIndex = 0
    this.tte = tte
    this.defaultText = defaultText
    this.appId = appId
    this.audioData = []
    this.rawAudioData = []
    this.audioDataOffset = 0
    this.audioTextOffset = 0
    this.continueConnect = false
    this.status = 'init'
    this.resumeCb = resumeCb
    this.suspendCb = suspendCb
    transWorker.onmessage = (e) => {
      this.audioData.push(...e.data.data)
      this.rawAudioData.push(...e.data.rawAudioData)
    }
  }
  // 修改录音听写状态
  setStatus(status) {
    this.onWillStatusChange && this.onWillStatusChange(this.status, status)
    this.status = status
  }
  // 设置合成相关参数
  setParams({ speed, voice, pitch, text, voiceName, tte, nextCb }) {
    speed !== undefined && (this.speed = speed)
    voice !== undefined && (this.voice = voice)
    pitch !== undefined && (this.pitch = pitch)
    text && (this.text = text)
    tte && (this.tte = tte)
    voiceName && (this.voiceName = voiceName)
    this.resetAudio()
    this.nextCb = nextCb
  }
  // 连接websocket
  connectWebSocket() {
    return getWebsocketUrl().then((url) => {
      let ttsWS
      if ('WebSocket' in window) {
        ttsWS = new WebSocket(url)
      } else if ('MozWebSocket' in window) {
        ttsWS = new MozWebSocket(url)
      } else {
        alert('浏览器不支持WebSocket')
        return
      }
      this.ttsWS = ttsWS
      ttsWS.onopen = (e) => {
        this.webSocketSend(this.text[this.textIndex])
        this.playTimeout = setTimeout(() => {
          console.log(this.continueConnect)
          if (!this.continueConnect) {
            this.audioPlay()
          }
        }, 1000)
      }
      ttsWS.onmessage = (e) => {
        this.result(e.data)
      }
      ttsWS.onerror = (e) => {
        clearTimeout(this.playTimeout)
        this.setStatus('errorTTS')
        // alert('WebSocket报错，请f12查看详情')
        console.error(`详情查看：${encodeURI(url.replace('wss:', 'https:'))}`)
      }
      ttsWS.onclose = (e) => {
        if (this.cb) {
          this.cb()
          this.cb = null
        } else {
          console.log(this.audioTextOffset, this.text)
          if (this.audioTextOffset < this.text[this.textIndex].text.length - 1) {
            this.continueConnect = true
            this.connectWebSocket()
          } else {
            this.audioTextOffset = 0
            this.continueConnect = false
          }
        }
      }
    })
  }
  // 处理音频数据
  transToAudioData(audioData) {}
  // websocket发送数据
  webSocketSend({ text, speed }) {
    console.log('webSocketSend', text, speed)
    var params = {
      common: {
        app_id: this.appId // APPID
      },
      business: {
        aue: 'raw',
        auf: 'audio/L16;rate=16000',
        vcn: this.voiceName,
        speed,
        volume: this.voice,
        pitch: this.pitch,
        bgs: 0,
        tte: this.tte
      },
      data: {
        status: 2,
        text: this.encodeText(text.slice(this.audioTextOffset, (this.audioTextOffset += 2000)) || this.defaultText, this.tte === 'unicode' ? 'base64&utf16le' : '')
      }
    }
    this.ttsWS.send(JSON.stringify(params))
  }
  encodeText(text, encoding) {
    switch (encoding) {
      case 'utf16le': {
        let buf = new ArrayBuffer(text.length * 4)
        let bufView = new Uint16Array(buf)
        for (let i = 0, strlen = text.length; i < strlen; i++) {
          bufView[i] = text.charCodeAt(i)
        }
        return buf
      }
      case 'buffer2Base64': {
        let binary = ''
        let bytes = new Uint8Array(text)
        let len = bytes.byteLength
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        return window.btoa(binary)
      }
      case 'base64&utf16le': {
        return this.encodeText(this.encodeText(text, 'utf16le'), 'buffer2Base64')
      }
      default: {
        return Base64.encode(text)
      }
    }
  }
  // websocket接收数据的处理
  result(resultData) {
    let jsonData = JSON.parse(resultData)
    // 合成失败
    if (jsonData.code !== 0) {
      alert(`合成失败: ${jsonData.code}:${jsonData.message}`)
      console.error(`${jsonData.code}:${jsonData.message}`)
      this.resetAudio()
      return
    }
    transWorker.postMessage(jsonData.data.audio)

    if (jsonData.code === 0 && jsonData.data.status === 2) {
      console.log('接收完成')
      console.log(this.ttsWS)
      this.ttsWS.close()
    }
  }
  // 重置音频数据
  resetAudio(cb) {
    this.audioStop()
    this.setStatus('init')
    this.audioDataOffset = 0
    this.audioTextOffset = 0
    this.continueConnect = false
    this.audioData = []
    this.rawAudioData = []
    if (this.ttsWS) {
      if (this.ttsWS.readyState === 2 || this.ttsWS.readyState === 3) {
        cb && cb()
      } else {
        this.ttsWS.close()
        this.cb = cb
      }
    }

    console.log('closews')
    clearTimeout(this.playTimeout)
  }
  // 音频初始化
  audioInit() {
    let AudioContext = window.AudioContext || window.webkitAudioContext
    if (AudioContext) {
      this.audioContext = new AudioContext()
      this.audioContext.onstatechange = () => {
        console.log('onstatechange', this.audioContext.state)
        if (this.audioContext.state === 'running') {
          this.resumeCb && this.resumeCb()
        } else if (this.audioContext.state === 'suspended') {
          this.suspendCb && this.suspendCb()
        }
      }
      this.audioContext.resume()
      this.audioDataOffset = 0
      this.audioTextOffset = 0
      this.continueConnect = false
    }
  }
  // 音频播放
  audioPlay() {
    this.setStatus('play')
    let audioData = this.audioData.slice(this.audioDataOffset)
    this.audioDataOffset += audioData.length
    let audioBuffer = this.audioContext.createBuffer(1, audioData.length, 22050)
    let nowBuffering = audioBuffer.getChannelData(0)
    if (audioBuffer.copyToChannel) {
      audioBuffer.copyToChannel(new Float32Array(audioData), 0, 0)
    } else {
      for (let i = 0; i < audioData.length; i++) {
        nowBuffering[i] = audioData[i]
      }
    }
    let bufferSource = (this.bufferSource = this.audioContext.createBufferSource())
    bufferSource.buffer = audioBuffer
    bufferSource.connect(this.audioContext.destination)
    bufferSource.start()
    if (this.audioContext.state === 'suspended') {
      this.audioContext.resume()
    }
    bufferSource.onended = (event) => {
      console.log('bufferSource.onended')
      if (this.status !== 'play') {
        return
      }
      if (this.audioDataOffset < this.audioData.length) {
        this.audioPlay()
      } else if (this.textIndex < this.text.length - 1) {
        this.textIndex++
        this.connectWebSocket()
      } else {
        // this.audioStop()
        this.nextCb && this.nextCb()
        this.setStatus('bufferSourceEnd')
      }
    }
  }
  // 音频播放结束
  audioStop() {
    this.setStatus('endPlay')
    clearTimeout(this.playTimeout)
    this.audioDataOffset = 0
    if (this.bufferSource) {
      try {
        this.bufferSource.stop()
      } catch (e) {
        console.log(e)
      }
    }
  }
  start() {
    if (this.audioData.length) {
      this.audioPlay()
    } else {
      if (!this.audioContext) {
        this.audioInit()
      }
      if (!this.audioContext) {
        alert('该浏览器不支持webAudioApi相关接口')
        return
      }
      this.connectWebSocket()
    }
  }
  stop() {
    this.audioStop()
  }
}
export default {
  data() {
    return {
      dataLoading: false,
      isPause: true,
      title: '',
      editions: [],
      bookDetail: {},
      xiaoYangList: [],
      xiaoYangIndex: 0,
      id: '', //报纸或者书刊id
      articleText: '',
      readStatus: false,
      voices: ['x3_guange', 'x4_lingxiaoying_en', 'x2_wanshu', 'xiaoyan', 'aisjiuxu', 'aisxping', 'aisjinger', 'aisbabyxu'],
      speeds: [50, 30, 70]
    }
  },
  destroyed() {
    if (this.ttsRecorder) {
      if (this.readStatus) {
        this.ttsRecorder.stop()
      }
    }
  },
  watch: {
    xiaoYangIndex() {
      this.dataLoading = true
      if (this.ttsRecorder) {
        if (this.ttsRecorder.audioContext) {
          this.ttsRecorder.audioContext = null
        }
        this.ttsRecorder.textIndex = 0
        this.ttsRecorder.resetAudio(() => {
          this.getXiaoYangDetailInfo()
        })
      }
    }
  },
  methods: {
    back() {
      if (this.$route.query.from === 'content' && window.history.length > 1) {
        window.history.go(-1)
      } else {
        window.location.href = window.location.origin + '/elecPublish' + (this.$route.query.type === 'ebook' ? '/content?id=' : '/paperContent?id=') + this.id
      }
    },
    handleXiaoYangClick(xiaoYangId) {
      this.xiaoYangList.forEach((item, index) => {
        if (item.id === xiaoYangId) {
          this.xiaoYangIndex = index
          return false
        }
      })
    },
    createXiaoYangList() {
      let arr = []
      this.editions.forEach((edition) => {
        if (edition.xiaoYangList) {
          edition.xiaoYangList.forEach((xiaoyang) => {
            arr.push(xiaoyang)
          })
        }
      })
      this.xiaoYangList = arr
    },
    initTTSRecorder() {
      getBook.getTTSParam().then((res) => {
        if (res && res.data && res.status === 200) {
          APPID = res.data.data.appid
          API_KEY = res.data.data.apiKey
          API_SECRET = res.data.data.apiSecret
          this.ttsRecorder = new TTSRecorder({
            resumeCb: () => {
              this.isPause = false
            },
            suspendCb: () => {
              this.isPause = true
            }
          })
          this.getDetails()
          this.ttsRecorder.onWillStatusChange = (oldStatus, status) => {
            console.log('onWillStatusChange', status)
            if (status === 'play') {
              this.readStatus = true
              this.dataLoading = false
            } else if (status === 'endPlay') {
              this.readStatus = false
            }
          }
        }
      })
    },
    getDetails() {
      getBook.getArticleListByEpaperId({ epaperId: this.id, module: this.isPaper ? 'epaper' : 'ebook' }).then((res) => {
        console.log(res)
        if (res && res.data && res.status === 200) {
          this.editions = res.data.data
          // this.title = this.editions[0].baoMing
          if (this.editions.length) {
            this.createXiaoYangList()
            this.getXiaoYangDetailInfo()
          } else {
            this.dataLoading = false
          }
        }
      })
    },
    next() {
      if (this.xiaoYangIndex >= this.xiaoYangList.length - 1) {
        return
      } else {
        this.xiaoYangIndex++
      }
    },
    prev() {
      if (this.xiaoYangIndex <= 0) {
        return
      } else {
        this.xiaoYangIndex--
      }
    },
    getXiaoYangDetailInfo() {
      let articleItem = this.xiaoYangList[this.xiaoYangIndex]
      let article = formatDigitalArticle({ data: { data: articleItem } }).data.data
      this.articleText = article.content
      this.read()
    },
    resumeAudio() {
      if (this.ttsRecorder && this.ttsRecorder.audioContext) {
        if (this.ttsRecorder.audioContext.state === 'running') {
          if (this.xiaoYangIndex === this.xiaoYangList.length - 1 && this.ttsRecorder.status === 'bufferSourceEnd') {
            this.xiaoYangIndex = 0
            if (this.xiaoYangList.length === 1) {
              this.ttsRecorder.audioDataOffset = 0
              this.ttsRecorder.audioPlay()
              this.isPause = false
            }
          } else {
            this.ttsRecorder.audioContext.suspend()
          }
        } else if (this.ttsRecorder.audioContext.state === 'suspended') {
          this.ttsRecorder.audioContext.resume()
        }
      }
    },
    read() {
      if (this.ttsRecorder) {
        let speedReg = /<span data-w-e-type="speed" data-w-e-is-inline="" data-w-e-is-void="" data-speed-start="true" data-speed="\d+" data-timestamp="\d+"><\/span>(.+?)<span data-w-e-type="speed" data-w-e-is-inline="" data-w-e-is-void="" data-speed-start="false" data-speed="\d+" data-timestamp="\d+"><\/span>/g
        let diffSpeedArticleTextArray = []
        let flag = true,
          lastIndex = 0,
          speedRegExecResult
        while (flag) {
          speedRegExecResult = speedReg.exec(this.articleText)
          if (speedRegExecResult) {
            diffSpeedArticleTextArray.push({
              text: this.articleText.slice(lastIndex, speedRegExecResult.index),
              speed: this.articleVoiceSpeed
            })
            diffSpeedArticleTextArray.push({
              text: speedRegExecResult[0],
              speed: speedRegExecResult[0].match(/data-speed="(\d+)"/)[1] * 1
            })
          } else {
            if (lastIndex !== this.articleText.length - 1) {
              diffSpeedArticleTextArray.push({
                text: this.articleText.slice(lastIndex),
                speed: this.articleVoiceSpeed
              })
            }
            flag = false
          }
          lastIndex = speedReg.lastIndex
        }
        let voiceId = this.bookDetail.voiceNumber ? this.bookDetail.voiceNumber - 1 : 0
        let textArr = []
        diffSpeedArticleTextArray.forEach((item) => {
          let text = ''
          let articleTextArray = item.text.split(/<\/div>|<br>/)
          for (let a in articleTextArray) {
            if (articleTextArray.hasOwnProperty(a)) {
              articleTextArray[a] = articleTextArray[a].replace(/<[^>]+>/g, '')
              if (!articleTextArray[a]) {
                continue
              }
              let lastChar = articleTextArray[a].substr(articleTextArray[a].length - 1, 1)
              if (!(lastChar === '。' || lastChar === '！')) {
                articleTextArray[a] += '。'
              }
              articleTextArray[a] = convertEnName(articleTextArray[a])
              text += articleTextArray[a]
            }
          }
          if (text.trim().length) {
            textArr.push({ text, speed: item.speed })
          }
        })
        let text = convertEnName(textArr.map((item) => item.text).join(''))
        console.log('text', text)
        if (text.length) {
          let validText = text.match(/[\u4e00-\u9fa5\uf900-\ufa2da-zA-Z0-9.。，：]/g)
          if (validText.length / text.length > 0.5) {
            let that = this
            this.ttsRecorder.setParams({
              text: textArr,
              voiceName: this.voices[voiceId],
              speed: this.articleVoiceSpeed,
              nextCb() {
                that.isPause = true
                that.next()
              }
            })
            this.ttsRecorder.start()
          } else {
            this.$alert('暂不支持该语种')
          }
        } else {
          this.next()
        }
      }
    },
    getBookDetails(params, callback) {
      let url = this.isPaper ? getBook.GetPaperDetails : getBook.GetMobileBookDetails
      url(params).then((res) => {
        if (res && res.data && res.status === 200) {
          this.bookDetail = res.data.data
          this.title = this.bookDetail.title
          callback()
        }
      })
    }
  },
  computed: {
    ...mapState('book', ['isMobile']),
    xiaoYangId() {
      return this.xiaoYangList[this.xiaoYangIndex]?.id
    },
    isPaper() {
      return this.$route.query.type === 'epaper'
    },
    articleVoiceSpeed() {
      return this.bookDetail.voiceSpeed !== 3 ? this.speeds[this.bookDetail.voiceSpeed || 0] : this.bookDetail.userVoiceSpeed
    }
  },
  created() {
    this.dataLoading = true
    this.id = this.$route.query.id
    this.getBookDetails({ id: this.id }, () => {
      this.initTTSRecorder()
    })
  }
}
</script>

<style lang="scss">
.page-article-listen {
  width: 600px;
  height: 100%;
  margin: auto;
  border: 1px solid #d2d2d2;
  position: relative;
  .header {
    background-color: #f5f5f5;
    padding: 0 7px;
    position: relative;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    .back {
      position: absolute;
      left: 0;
      top: 0;
      height: 40px;
      text-align: left;
      line-height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        margin-right: 3px;
        height: 27px;
      }
      span {
        line-height: 40px;
      }
    }
    .title {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      font-size: 16px;
      text-overflow: ellipsis;
      width: calc(100% - 90px);
      margin-left: 60px;
    }
  }
  .main {
    overflow: auto;
    height: calc(100% - 40px - 95px);
    padding: 10px 7px;
    font-size: 20px;
    .edition {
      .article-item {
        cursor: pointer;
      }
      > .title {
        color: rgba(223, 88, 19, 1);
        font-weight: 700;
      }
      .title {
        padding: 12px 50px 12px 27px;
        line-height: 36px;
      }
      .el-divider {
        margin: 0;
        background-color: rgba(239, 239, 239, 1);
      }
      > .el-divider {
        height: 4px;
      }
      img {
        position: absolute;
        width: 16px;
        height: 20px;
        right: 20px;
        top: 0;
        bottom: 0;
        margin: auto;
        display: none;
      }
      .active {
        color: rgba(223, 88, 19, 1);
        position: relative;
        .title::before {
          position: absolute;
          content: '';
          width: 8px;
          background: rgba(223, 88, 19, 1);
          left: -8px;
          top: 0;
          bottom: 0;
        }
        img {
          display: block;
        }
      }
    }
    .edition:last-of-type {
      > .el-divider {
        display: none;
      }
    }
  }
  .bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid rgba(229, 229, 229, 1);
    display: flex;
    justify-content: space-around;
    padding: 0 20px;
    align-items: center;
    height: 94px;
    width: 560px;
    margin: auto;
    background-color: #fff;
    color: #000;
    > div {
      padding: 10px 20px;
    }
    img {
      width: 40px;
      height: 40px;
      vertical-align: middle;
    }
    .center {
      img {
        width: 64px;
        height: 64px;
      }
    }
    .inactive {
      color: #9b9aa7;
    }
    .disable {
      cursor: not-allowed;
      .activeImg {
        display: none;
      }
      .inActiveImg {
        display: inline;
      }
    }
    .useable {
      cursor: pointer;
      .activeImg {
        display: inline;
      }
      .inActiveImg {
        display: none;
      }
    }
  }
  .digital-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9998;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    .text {
      position: fixed;
      top: 50%;
      left: 50%;
      width: 200px;
      height: 30px;
      margin-left: -100px;
      margin-top: -15px;
      text-align: center;
      z-index: 9999;
      font-size: 24px;
      color: #ffffff;
    }
  }
}
.page-article-listen.mobile {
  border: 0;
  width: 100%;
  .main {
    height: calc(100% - 40px - 110px);
  }
  .bottom {
    margin: 0 15px;
    padding: 15px 0;
    width: calc(100% - 30px);
    height: 110px;
    .left,
    .right,
    .center {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
